import Vue from 'vue';
export const BadgeEventBus = new Vue();